<template>
  <div class="home-wrapper" :class="[menuList.length && 'has-footer']">
    <div style="z-index: 20">

      <Head :lanshow="ActiveName" />
      <!-- <NavBar class="nav-bar" /> -->
      <!-- <Foot /> -->

      <div class="home-inner">
        <!-- 举报入口 -->
        <div class="ReportingEntrance">
          <div class="title">
            <div class="text">举报查询</div>
            <div class="line" />
          </div>
          </div>
        </div>
        <!-- 搜索框 -->
        <div class="reportSearch" style="margin-bottom: 20.3rem">
          <i class="iconfont icon-sousuo"></i>
          <input type="tel" placeholder="请输入您需要查询的举报编码" v-model="sousuobianma" maxlength="30" />
          <span @click="sousuo" class="sousuoanniu">搜索</span>
        </div>
      <Footer :contact="homeInfo && homeInfo.contact && homeInfo.contact" />

    </div>
    <van-popup v-model="show" closeable close-icon="cross" class="popup-chaxun" :style="{ height: '90%', width: '90%' }">
      <div>
        <div class="chaxun-title">
          <h3>已查询到您的举报信息</h3>
        </div>

        <div class="biaoge">
          <div class="biaoge_title">
            <div v-for="(item, index) in jubaoxinxitou" :key="index">
              <div class="biaoge_title_title" :class="item.title == '查看' && 'biaoge_title_title_last'"><span>{{item.title}}</span></div>
            </div>
          </div>
          <div class="biaoge_content">
            <div v-for="(item) in jubaoxinxishen" :key="item.id">
              <div class="biaoge_content_content"><span>{{item.damageKindName}}</span></div>
              <div class="biaoge_content_content"><span>{{item.damageSubKindName}}</span></div>
              <div class="biaoge_content_content"><span>{{reportedPlatformMap[item.reportedPlatform]}}</span></div>
              <div class="biaoge_content_content"><span>{{time1Filter(item.createTime)}}</span></div>
              <div class="biaoge_content_content"><span @mousedown="chufa(item.content)">{{item.content}}</span></div>
              <div>
                <div class="biaoge_content_content">
                  <!-- <span :style="`color:${
                          item.status != 3 ? '#EA5F00' : '#7CB305'
                        }`">●</span>
                  <span style="
                          color: #646566;
                          font-size: 12px;
                          line-height: 1.5;
                          word-break: break-all;
                        ">
                    {{item.subStatus == 3 ? '人工判定无效': statusMap[item.status] }}
                  </span> -->
                  已受理
                </div>
              </div>
              <div @click="chankanhuifu(item.id)" class="huifucolor biaoge_content_content biaoge_content_content_last">
                查看回复 ></div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showshibai" closeable close-icon="close" class="popup-chaxunshibai">
      <div>
        <div class="chaxun-title">
          <h3>查询失败</h3>
        </div>
        <div class="chaxun-content">
          <div style="width: 20vw; text-align: center; margin: auto">
            <img src="../assets/img/警告.png" alt="" />
          </div>
          <h4>{{ errorMessage }}</h4>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="isShow" closeable close-icon="cross" class="popup-huifu" style="max-height: 90%;min-width:60%">
      <div>
        <div class="huifu-title">
          <h3>举报回复</h3>
        </div>
        <div class="huifu-content">
          <div v-if="lists.length !== 0">
            <div v-for="(item, index) in lists" :key="index">
              <div class="huifu-content_pic"> <img :src="require('../assets/img/成功@3x.png')" alt="" style="width: 5.33vw;height: 5.33vw;">
                {{item.replyValue || item.content}}</div>
              <div class="huifu-content-color"> <span>{{ item.orgName }}</span><span>{{&nbsp;}}</span> <span>{{ item.username }}</span>
                <span>{{
                 item.createTime ? timeFilter(item.createTime) : ""
                }}</span>
              </div>
              <div class="Underline_huifu"></div>
            </div>
          </div>
          <div v-if="lists.length == 0" class="meiyoushuju">
            <img src="../assets/img/举报失败.png" alt="" style="width: 30vw; height: 30vw" />

          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>

import City21 from '@/components/Home/city21.vue'
import Footer from '@/components/Footer.vue'
import SpecialArea from '@/components/Home/SpecialArea.vue'
import NewsInformation from '@/components/Home/NewsInformation.vue'
import Moment from 'moment'

import { mapState, mapMutations } from 'vuex'
export default {
  name: 'Home',
  data () {
    return {
      isLists: false,
      pageNum: 4,
      statusMap: {
        0: '待初审',
        1: '待受理',
        2: '待处置',
        3: '已处置'
      },
      reportedPlatformMap: {
        0: '网站网页',
        1: 'APP',
        2: '网络账号'
      },
      currentPage: 1,
      active: 0,
      // 定义数据接受评到列表
      menus: [],
      list: [],
      lists: [],
      jubaoxinxitou: [
        { title: '举报类型' },
        { title: '危害小类' },
        { title: '被举报平台' },
        { title: '举报时间' },
        { title: '举报内容' },
        { title: '举报进度' },
        { title: '查看' }
      ],
      jubaoxinxishen: [],
      isShiBai: false,
      showshibai: false,
      isShow: false,
      show: false,
      sousuobianma: '',
      cityShow: false,
      homeInfo: null,
      emptydata: null,
      sections: [],
      homePopShow: true,
      allSections: [
        {
          kind: [6, 9, 10],
          component: 'ChannelNews'
        },
        {
          kind: [8],
          component: 'Subject'
        },
        {
          kind: [7],
          component: 'Activity'
        },
        {
          kind: [11, 15],
          component: 'TabNews'
        },
        {
          kind: [12],
          component: 'NineColumn'
        },
        {
          kind: [13],
          component: 'ThreeRow'
        },
        {
          kind: [14],
          component: 'TwoRow'
        },
        {
          kind: [16],
          component: 'IconRow'
        }
      ]
    }
  },
  components: {
    City21,
    Footer,
    SpecialArea,
    NewsInformation
  },
  computed: {
    ...mapState(['lang', 'menuList', 'isShowLoading', 'homeSections', 'ActiveName'])
  },
  watch: {
    lang (val) {
      this.reload()
    },
    // 主页信息查询
    getHomeInfo () {
      this.apiGetHomeInfo()
      this.getBanner()
      // 用户是否登录
      this.$Api.userGet().then(res => {
        if (!res) localStorage.setItem('userInfo', '')
      }).catch(err => {
        console.log(err)
        localStorage.setItem('userInfo', '')
      })
      const token =
        localStorage.getItem('userInfo') &&
        JSON.parse(localStorage.getItem('userInfo')) &&
        JSON.parse(localStorage.getItem('userInfo')).token
      if (token) {
        // 显示登陆头像
        this.setActiveName(true)
      } else {
        this.setActiveName(false)
      }
    }
  },
  created () {
    this.getHomeInfo()
    // 调用获取频道列表
    this.loadmenus()
    this.setShowLoading(false)
  },
  mounted () {
    this.$nextTick(() => {
      this.$Common.pageShare()
    })
    this.$Common.track('load', {
      name: '首页',
      refer: document.referrer || window.location.href
    })
  },
  methods: {
    ...mapMutations(['setShowLoading', 'setProductTitle', 'setActiveName']),
    goUrl (url) {
      window.location.href = url
    },
    goWebsite(){
      this.$router.push({
        path: 'news/179',
        query: {
          lan: this.lang
        }
      })
    },
    // 主页信息查询
    getHomeInfo () {
      this.apiGetHomeInfo()
      this.getBanner()
      // 用户是否登录
      const token =
        localStorage.getItem('userInfo') &&
        JSON.parse(localStorage.getItem('userInfo')) &&
        JSON.parse(localStorage.getItem('userInfo')).token
      if (token) {
        // 显示登陆头像
        this.setActiveName(true)
      } else {
        this.setActiveName(false)
      }
    },
    apiGetHomeInfo () {
      this.$Api
        .getHomeInfo({})
        .then((data) => {
          if (data) {
            this.homeInfo = data
            data.conference &&
              data.conference.name &&
              this.setProductTitle(data.conference.name)
            data.sections && data.sections.length && this.getSections()
          }
          // this.setShowLoading(false)
        })
        .catch(() => {
          this.emptydata = {
            type: 'nonetwork'
          }
          // this.setShowLoading(false)
        })
    },
    getSections () {
      this.homeInfo.sections.forEach((Sval, Sidx) => {
        this.allSections.forEach((val, idx) => {
          if (val.kind.indexOf(Sval.kind) > -1) {
            this.sections.push(
              Object.assign(
                JSON.parse(JSON.stringify(val)),
                JSON.parse(JSON.stringify(Sval))
              )
            )
          }
        })
      })
    },
    reload () {
      this.setShowLoading(true)
      this.homeInfo = null
      this.sections = []
      this.$nextTick(() => {
        this.$Common.pageShare()
        this.getHomeInfo()
      })
    },
    homePopClose () {
      this.homePopShow = false
    },
    cityLink () {
      this.cityShow = true
    },
    back () {
      this.cityShow = false
    },
    toReportInstructions (id) {
      if (id == 9) {
        this.$router.push('/otherReports')
      } else {
        this.$router.push({ path: `/reportInstructions/${id}`, query: { id } })
      }
    },
    sousuo () {
      if (this.sousuobianma.trim() == '') return this.$toast('编码不能为空')
      this.$toast.loading({
        duration: 1000, // 持续展示 toast
        forbidClick: true
      })
      this.$Api
        .reportQueryReportByCode({ code: this.sousuobianma }, {
          callback: (res) => {
            if (res.status !== 0) {
              this.errorMessage = res.message
            }
          }
        })
        .then((res) => {
          if (res) {
            const arr = [res]
            this.pageNum = [res].length
            this.jubaoxinxishen = arr
            this.show = true
          } else {
            this.showshibai = true
          }
        })
        .catch((error) => {
          this.showshibai = true
        })
      // 获取搜索结果状态是否失败
      // if (this.isShiBai) {
      //   this.showshibai = true;
      // } else {
      //   this.show = true;
      // }
    },
    chankanhuifu (id) {
      this.isShow = true
      // 请求接口数据
      this.$Api.reportQueryReportReply({ reportId: id }).then((res) => {
        if (res) {
          this.lists = res
          if (!(res.length > 0)) {
            this.isLists = true
          }
        } else {
        }
      })
    },
    getBanner () {
      this.$Api
        .commonBlock({
          relateType: 4,
          blockType: 1
        })
        .then((data) => {
          if (data && data.list && data.list.length) {
            setTimeout(() => {
              this.list = data.list
              this.$refs.swipe.resize()
            }, 500)
          }
        }).catch(() => { })
    },
    slimImg (img) {
      return this.$Common.slimImg(img, 750)
    },
    loadmenus () {
      this.$Api.getMenu({}).then((data) => {
        if (data) {
          const menus = data.menus
          if (menus && menus.length) {
            // this.setMenuList(this.formatMenus(menus))
            this.menus = menus
          }
        }
      })
    },
    pageChange (e) {
      this.$Api
        .reportQueryReportByCode({ code: this.sousuobianma, page: e }, {
          callback: (res) => {
            if (res.status !== 0) {
              this.errorMessage = res.message
            }
          }
        })
        .then((res) => {
          if (res) {
            const arr = [res]
            this.pageNum = [res].length
            this.jubaoxinxishen = arr
          }
        })
        .catch((error) => {
          this.showshibai = true
        })
    },
    time1Filter (time) {
      return Moment(time).format('YYYY-MM-DD')
    },
    // 格式化时间精确到秒
    timeFilter (time) {
      return Moment(time).format('YYYY-MM-DD HH:mm')
    },
    toWebsite (url) {
      if (url) window.open(url)
    },

    chufa (content) {
      this.$toast({
        duration: 5000, // 持续展示 toast
        // forbidClick: true,
        message: content
      })
    }
  }
}
</script>

<style lang="scss">
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  font-size: 7vw;
}
.home-wrapper {
  .home-inner {
    position: relative;
    // margin-top: 3.32vw;
    padding: 0 4vw;
    padding-top: 4vw;
  }
  .home-robot {
    position: fixed;
    top: 50%;
    right: 2.13vw;
    transform: translateY(-50%);
    text-align: center;
    text-decoration: none;
    z-index: 5;
    img {
      width: 13.333vw;
      border-radius: 50%;
      box-shadow: 0 0.37vw 3.704vw 0 #1aa2f2;
    }
    span {
      display: block;
      color: #fff;
      font-size: 2.222vw;
      line-height: 1.4;
      text-shadow: 0 0 2.5vw #04083c;
    }
  }
  .view-num {
    color: #fff;
    position: absolute;
    right: 4.63vw;
    top: 3.981vw;
    background-color: rgba(0, 14, 30, 0.5);
    display: flex;
    overflow: hidden;
    span {
      color: $color;
      font-size: 2.963vw;
      background-color: #00e4ff;
      border: 1px solid #00e4ff;
      height: 5.556vw;
      display: flex;
      align-items: center;
      padding: 0 1.667vw;
      font-weight: bold;
    }
    p {
      border: 1px solid #00e4ff;
      height: 5.556vw;
      display: flex;
      align-items: center;
    }
    b {
      color: #00e4ff;
      font-size: 3.148vw;
      padding: 0 0.741vw 0 1.667vw;
    }
    i {
      font-size: 2.87vw;
      padding-right: 1.667vw;
      font-style: normal;
    }
  }
  .home-pop {
    position: fixed;
    right: 5vw;
    bottom: 20vw;
    width: 20vw;
    z-index: 10;
    .home-pop-close {
      width: 6vw;
      height: 6vw;
      background: url("../assets/img/close.png") no-repeat center center;
      background-size: 100% 100%;
      position: absolute;
      right: -3vw;
      top: -3vw;
    }
  }
}

.ReportingEntrance {
  margin-bottom: 5vw;
  .title {
    margin-bottom: 8.26vw;
  }
  .ReportTitle {
    position: relative;
    padding: 5vw 0 5vw 41vw;
    font-size: 4.815vw;
    font-weight: 700;
    i {
      position: absolute;
      top: 11vw;
      left: 48vw;
      padding-left: 5vw;
      border-bottom: 0.556vw solid #265cdd;
    }
  }
  width: 100%;

  ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    li {
      width: 24%;
      padding: 3vw 1vw;
      text-align: center;
      font-weight: 700;
      border: 1px solid #dadada;
      white-space: nowrap;
      margin-bottom: 3vw;
      font-size: 4vw;
      i {
        font-style: normal;
      }
    }
  }
}
.ReportingAgency {
  .title {
    margin-bottom: 8.26vw;
  }
  margin: 8vw 0 0 0;
  .ReportContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 12vw;
    .City21,
    .ReportingCenter {
      width: 44.93vw;
      height: 26.66vw;
      justify-content: center;
      // line-height: 26.66vw;
      display: flex;
      align-items: center;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      color: #333333;
      font-weight: bold;
      background: #ffffff;
      border: 0.26vw solid #dadada;
    }
  }
}
.popup-chaxun {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}
.popup-chaxun > div {
  margin: 12vw 3vw;
  font-size: 4vw;
  text-align: center;
  .chaxun-title {
    position: absolute;
    top: 5vw;
    left: 4vw;
  }
  .biaoge {
    display: flex;
    justify-content: space-around;
    margin-top: 4vw;
    border-top: 1px solid #d9d9d9;
  }
}
.popup-huifu {
  box-sizing: border-box;
  //   display: flex;
  //   justify-content: space-between;
}
.huifu-title {
  font-size: 5.5vw;
  margin-top: 4vw;
  padding-left: 4vw;
  padding-bottom: 7vw;
}
.popup-chaxunshibai {
  width: 80%;
}
.popup-chaxunshibai > div {
  margin: 12vw 3vw;
  font-size: 4vw;
  text-align: center;
  .chaxun-title {
    position: absolute;
    top: 5vw;
    left: 4vw;
  }
  .chaxun-content {
    padding-top: 10vw;
    h4 {
      margin-top: 3vw;
    }
  }
}
.my-swipe .van-swipe-item {
  width: 100vw;
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}
.huifucolor {
  .van-grid-item__text {
    color: #6465f2;
  }
}
.report-progress {
  display: flex;
  justify-content: center;
  align-items: center;
  .report-progress-circle {
    width: 0.5rem;
    height: 0.5rem;
    margin-right: 5 / 16rem;
    border-radius: 50%;
  }
  .report-progress-text {
    font-size: 14 / 16rem;
    font-family: MicrosoftYaHei;
    color: rgba(0, 0, 0, 0.65);
  }
}
.Refute_rumor {
  display: flex;
  justify-content: space-between;
  .Refute_rumor_img {
    width: 44.93vw;
    height: 26.66vw;
  }
}
.meiyoushuju {
  text-align: center;
  margin-bottom: 7vw;
}
.report-entrance {
  display: flex;
  flex-wrap: wrap;
  // flex-direction: column;
  justify-content: space-between;
  // align-items: center;
  .report-entrance-img {
    width: 29.33vw;
    height: 21.33vw;
    margin-top: 2vw;
  }
}

</style>
